import styled from "@emotion/styled";
import { rem } from "@triumph/design-system";

export const ButtonsWrapper = styled.div`
  display: flex;
  padding: 30px 0px;
`;

export const SubmitButton = styled.div`
  margin-left: 10px;
`;

export const ExportButton = styled.div`
  margin-left: auto;
`;

export const SchedulePaymentButton = styled.div`
  margin-left: auto;
`;

export const BillingReminderTableWrapper = styled.div`
  tfoot {
    tr:nth-of-type(1) td {
      border-bottom: none;
    }

    tr {
      background-color: unset;
      td {
        line-height: ${rem(24)};
        padding-top: ${rem(20)};
        padding-bottom: ${rem(20)};
      }
    }
  }
`;
